<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
      <div class="page-card-body" ref="pageRoot">
        <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
          <el-input
            v-model="keyword"
            placeholder="手机号 姓名"
            style="width:240px"
            clearable
            @keyup.enter.native="load"
          />
          <el-select
            v-model="hasLogisticsPermission"
            placeholder="物流管理员权限"
            clearable
            style="width:180px"
            @change="load"
          >
            <el-option :value="1" label="有权限" />
            <el-option :value="0" label="无权限" />
          </el-select>
          <el-button type="primary" @click="load">查询</el-button>
        </div>

        <el-table :data="list" :height="tableHeight" style="width:100%;" size="small">
          <el-table-column prop="nickName" label="姓名" width="180">
            <template slot-scope="s">
              {{ s.row.nickName || '未知' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="150">
            <template slot-scope="s">
              {{ s.row.phone || '未绑定' }}
            </template>
          </el-table-column>
          <el-table-column prop="hasLogisticsPermission" label="物流管理员权限" width="130">
            <template slot-scope="s">
              <el-tag :type="s.row.hasLogisticsPermission === 1 ? 'success' : 'info'">
                {{ s.row.hasLogisticsPermission === 1 ? '有权限' : '无权限' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="roleName" label="管理员角色" width="120">
            <template slot-scope="s">
              {{ s.row.roleName || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="lastLoginTime" label="最后登录时间" width="180" />
          <el-table-column prop="cTime" label="注册时间" width="180" />
          <el-table-column label="操作" width="160">
            <template slot-scope="s">
              <el-button type="text" @click="openPermissionDlg(s.row)">配置权限</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div ref="pagerBar" class="pager-bar">
          <el-pagination
            layout="total, prev, pager, next"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="load"
          />
        </div>
      </div>
    </el-card>

    <el-dialog title="配置物流管理员权限" :visible.sync="permissionDlg" width="460px">
      <el-form :model="permissionForm" label-width="110px">
        <el-form-item label="用户">
          <span>{{ currentUser ? (currentUser.nickName || '-') : '-' }}</span>
        </el-form-item>
        <el-form-item label="手机号">
          <span>{{ currentUser ? (currentUser.phone || '-') : '-' }}</span>
        </el-form-item>
        <el-form-item label="启用权限">
          <el-switch v-model="permissionForm.enabled" />
        </el-form-item>
        <el-form-item v-if="permissionForm.enabled" label="管理员角色">
          <el-select v-model="permissionForm.roleType" style="width:100%">
            <el-option :value="1" label="物流员" />
            <el-option :value="2" label="行查员" />
            <el-option :value="3" label="物流员和行查员" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="permissionDlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="savePermission">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'BizAppUser',
  mixins: [tableAutoHeight],
  data() {
    return {
      keyword: '',
      hasLogisticsPermission: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],

      permissionDlg: false,
      saving: false,
      currentUser: null,
      permissionForm: {
        enabled: false,
        roleType: 1
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    // 加载小程序用户列表
    async load(page) {
      if (typeof page === 'number') this.pageNum = page
      const pageData = await request.get('/admin/api/biz/app-user/page', {
        params: {
          keyword: this.keyword,
          hasLogisticsPermission: this.hasLogisticsPermission,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
      this.list = pageData.records || []
      this.total = pageData.total || 0
      this.$nextTick(() => this.updateTableHeight())
    },
    // 打开权限配置窗口
    openPermissionDlg(row) {
      this.currentUser = row
      this.permissionForm = {
        enabled: row.hasLogisticsPermission === 1,
        roleType: row.roleType || 1
      }
      this.permissionDlg = true
    },
    // 保存权限配置
    async savePermission() {
      if (!this.currentUser || this.saving) return
      if (this.permissionForm.enabled && !this.permissionForm.roleType) {
        this.$message.warning('请选择管理员角色')
        return
      }
      this.saving = true
      try {
        await request.put(`/admin/api/biz/app-user/${this.currentUser.id}/logisticsPermission`, {
          enabled: this.permissionForm.enabled,
          roleType: this.permissionForm.enabled ? this.permissionForm.roleType : null
        })
        this.$message.success('保存成功')
        this.permissionDlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>